import http from '@/utils/axios'
import { AppDispatch } from '..'

/**
 * 获取视频配置
 */
export const API_getVideo = (): any => {
  return async (dispatch: AppDispatch) => {
    const res = await http.get('show/video/getList')
    if (res.code === 0) {
      const arr = res.data || []
      const obj = {} as { 1: string; 2: string; 3: string }
      arr.forEach((v: { id: 1 | 2 | 3; filePath: string }) => {
        obj[v.id] = v.filePath
      })
      dispatch({ type: 'layout/videos', payload: obj })
    }
  }
}

// 字典-树列表 get show/dict/getTree

// 字典-详情 get show/dict/detail/{id}

// 访问量统计 post vi/visit/add
export const API_visitCount = (): any => {
  return () =>
    http.post('vi/visit/add', {
      num: 'web_1',
      type: 'visit'
    })
}
